"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollArea.context.ts
const [ScrollAreaProvider, useScrollAreaContext] = createSafeContext("ScrollArea.Root component was not found in tree");
//#endregion
export { ScrollAreaProvider, useScrollAreaContext };

//# sourceMappingURL=ScrollArea.context.mjs.map